const { REACT_APP_AIRTABLE_API_KEY, REACT_APP_AIRTABLE_API_URL } = process.env;

export const retrieveEmployees = () => {
	return fetch(REACT_APP_AIRTABLE_API_URL + '/Employees', {
		method: 'GET',
		headers: {
			'Authorization': 'Bearer ' + REACT_APP_AIRTABLE_API_KEY,
		}
	})
		.then(resp => resp.json())
		.then(json => json);
}

export const retrieveEmployee = (id) => {
	return fetch(REACT_APP_AIRTABLE_API_URL + "/Employees/" + id, {
		method: 'GET',
		headers: {
			'Authorization': 'Bearer ' + REACT_APP_AIRTABLE_API_KEY,
		}
	})
		.then(resp => resp.json())
		.then(json => json);
}



// WEBPACK FOOTER //
// ./src/utils/retrieveEmployees.js